<template>
  <div v-if="showComponent">
    <vs-card class="mt-5">
      <div slot="header">
        <h3>{{ title }}</h3>
      </div>
      <div class="vx-row mt-4">
        <!-- Nome -->
        <div class="vx-col lg:w-1/4 w-full mb-2">
          <vs-input
            class="w-full"
            label="Nome"
            name="Nome"
            v-model="formDadosTerceiro.nome"
          />
        </div>

        <!-- Contato 1 -->
        <div class="vx-col lg:w-1/6 w-full mb-2">
          <vs-input
            class="w-full"
            label="Contato 1"
            name="Contato 1"
            v-mask="'(##) #####-####'"
            v-model="formDadosTerceiro.contato1"
          />
        </div>

        <!-- Contato 2 -->
        <div class="vx-col lg:w-1/6 w-full mb-2">
          <vs-input
            class="w-full"
            label="Contato 2"
            name="Contato 2"
            v-mask="'(##) #####-####'"
            v-model="formDadosTerceiro.contato2"
          />
        </div>

        <!-- Email -->
        <div class="vx-col lg:w-1/4 w-full mb-2">
          <vs-input
            class="w-full"
            label="Email"
            name="Email"
            v-model="formDadosTerceiro.email"
          />
        </div>

        <!-- Gênero -->
        <div class="vx-col lg:w-1/6 w-full mb-2">
          <label class="vs-select--label">Gênero</label>
          <v-select
            class="selectStyle"
            :options="listGeneros"
            name="Gênero"
            id="Gênero"
            v-model="formDadosTerceiro.sexo"
            label="label"
            :reduce="(item) => item.label"
          ></v-select>
        </div>
      </div>

      <div class="vx-row mt-4">
        <!-- CPF/CNPJ -->
        <div class="vx-col lg:w-1/6 w-full mb-2">
          <vs-input
            class="w-full"
            label="CPF"
            name="CPF"
            v-model="formDadosTerceiro.cpfcnpj"
            v-mask="maskCPFCNPJ"
            @input="formDadosTerceiro.cpfcnpj = $event.toUpperCase()"
          />
        </div>

        <!-- RG -->
        <div class="vx-col lg:w-1/6 w-full mb-2">
          <vs-input
            class="w-full"
            label="RG"
            name="RG"
            v-model="formDadosTerceiro.rgIe"
          />
        </div>

        <!-- Órgão de Expedição -->
        <div class="vx-col lg:w-1/6 w-full mb-2">
          <vs-input
            class="w-full"
            label="Órgão de Expedição"
            name="Órgão de Expedição"
            v-model="formDadosTerceiro.orgaoExpedicaoRg"
          />
        </div>

        <!-- Data de Expedição -->
        <div class="vx-col lg:w-1/6 w-full mb-2">
          <label class="vs-input--label">Data da Expedição</label>
          <div class="inputData">
            <flat-pickr
              :config="configDateTimePickerDay"
              v-model="formDadosTerceiro.dataExpedicaoRg"
              placeholder="DD/MM/AAAA"
              name="Data da Expedição"
            />
          </div>
        </div>

        <!-- CNH -->
        <div class="vx-col lg:w-1/6 w-full mb-2">
          <vs-input
            class="w-full"
            label="CNH"
            name="CNH"
            v-model="formDadosTerceiro.cnh"
            v-mask="'###########'"
          />
        </div>

        <!-- Categoria -->
        <div class="vx-col lg:w-1/6 w-full mb-2">
          <label class="vs-select--label">Categoria</label>
          <v-select
            :multiple="true"
            class="selectStyle"
            :options="listCategorias"
            name="Categoria"
            id="Categoria"
            v-model="formDadosTerceiro.categoriaCnh"
            label="label"
            :reduce="(item) => item.label"
          ></v-select>
        </div>
      </div>

      <div class="vx-row mt-4">
        <!-- CEP -->
        <div class="vx-col lg:w-1/6 w-full mb-2">
          <vs-input
            class="w-full"
            label="CEP"
            v-mask="'##.###-###'"
            v-model="formDadosTerceiro.cep"
            name="CEP"
            @keyup.native="keymonitor"
          />
        </div>

        <!-- Endereço -->
        <div class="vx-col lg:w-1/5 w-full mb-2">
          <vs-input
            class="w-full"
            label="Endereço"
            name="Endereço"
            v-model="formDadosTerceiro.endereco"
          />
        </div>

        <!-- Número -->
        <div class="vx-col lg:w-1/12 w-full mb-2">
          <vs-input
            class="w-full"
            label="Número"
            name="Número"
            v-model="formDadosTerceiro.numero"
          />
        </div>

        <!-- Bairro -->
        <div class="vx-col lg:w-1/6 w-full mb-2">
          <vs-input
            class="w-full"
            label="Bairro"
            name="Bairro"
            v-model="formDadosTerceiro.bairro"
          />
        </div>

        <!-- Estado -->
        <div class="vx-col lg:w-1/6 w-full mb-2">
          <label class="vs-select--label">Estado</label>
          <v-select
            class="selectStyle"
            :options="listEstados"
            name="Estado"
            id="Estado"
            v-model="formDadosTerceiro.estado"
            label="label"
            :reduce="(item) => item.id"
            @input="buscaCidade()"
          ></v-select>
        </div>

        <!-- Cidade -->
        <div class="vx-col lg:w-1/5 w-full mb-2">
          <label class="vs-select--label">Cidade</label>
          <v-select
            class="selectStyle"
            :options="listCidades"
            name="Cidade"
            id="Cidade"
            v-model="formDadosTerceiro.cidade"
            label="label"
            :reduce="(item) => item.id"
          ></v-select>
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import flatPickr from 'vue-flatpickr-component';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';

import service from './../../../../../services';
import notify from '../../../../../utils/notify';
import { LIST_CATEGORIAS_CNH } from './../const';
import { DOCUMENT_MASK } from '../../../../../constants/cpfCnpj';

export default {
  props: {
    formData: Object,
    dominios: Object,
    title: {
      type: String,
      default: 'Dados do Terceiro',
    },
  },
  components: { vSelect, flatPickr },
  watch: {
    formData(value) {
      if (!value.dadosTerceiro) {
        this.showComponent = false;
        console.error('ERRO NO CONTRATO DO OBJETO - DADOS TERCEIROS FORM');
        return;
      }

      this.formDadosTerceiro = Object.assign(
        this.formDadosTerceiro,
        value.dadosTerceiro,
      );

      // eslint-disable-next-line vue/no-mutating-props
      this.formData.dadosTerceiro = this.formDadosTerceiro;
    },
  },
  data() {
    return {
      DOCUMENT_MASK,
      showComponent: true,
      formDadosTerceiro: {
        nome: null,
        contato1: null,
        contato2: null,
        email: null,
        cpfcnpj: null,
        rgIe: null,
        orgaoExpedicaoRg: null,
        dataExpedicaoRg: null,
        cnh: null,
        categoriaCnh: null,
        sexo: null,
        cep: null,
        endereco: null,
        numero: null,
        bairro: null,
        cidade: null,
        estado: null,
      },
      listGeneros: [],
      listCidades: [],
      listEstados: [],
      listCategorias: LIST_CATEGORIAS_CNH,

      // Configurações de Component
      configDateTimePickerDay: {
        dateFormat: 'd/m/Y',
        locale: Portuguese,
        time_24hr: true,
      },
      configDateTimePickerHour: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i',
        time_24hr: true,
      },
    };
  },
  methods: {
    keymonitor: async function () {
      if (this.formDadosTerceiro.cep.length == 10) {
        try {
          this.$vs.loading();

          const cepbusca = this.formDadosTerceiro.cep
            .replace('.', '')
            .replace('-', '');

          const result = await service.post('g', 'BuscaCEP', {
            cep: cepbusca,
          });

          this.formDadosTerceiro.endereco = result.data.street;
          this.formDadosTerceiro.bairro = result.data.neighborhood;
          this.formDadosTerceiro.cidade = result.data.city;
          this.formDadosTerceiro.estado = result.data.state;
          this.formDadosTerceiro.pais = result.data.country;
        } catch (error) {
          notify.notifyFail(this.$vs, error);
        } finally {
          this.$vs.loading.close();
        }
      }
    },
    async buscaCidade() {
      if (this.formDadosTerceiro.estado == null) {
        this.formDadosTerceiro.cidade = null;
        return;
      }

      try {
        this.$vs.loading();
        const result = await service.getAll(
          'g',
          {},
          `domMunicipio/list/codUf/${this.formDadosTerceiro.estado}`,
        );
        if (result) {
          result.data.forEach((cidade) => {
            this.listCidades.push({
              id: cidade.idCidade,
              label: cidade.nomeCidade,
            });
          });
        }
        this.$vs.loading.close();
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      }
    },
  },
  mounted() {
    if (!this.formData.dadosTerceiro) {
      this.showComponent = false;
      console.error('ERRO NO CONTRATO DO OBJETO - DADOS TERCEIROS FORM');
      return;
    }

    // eslint-disable-next-line vue/no-mutating-props
    this.formData.dadosTerceiro = this.formDadosTerceiro;

    this.listEstados = this.dominios.listEstados;
    this.listGeneros = this.dominios.listGeneros;
  },
  computed: {
    maskCPFCNPJ() {
      return !this.formDadosTerceiro.cpfcnpj ||
        this.formDadosTerceiro.cpfcnpj.length <= 14
        ? DOCUMENT_MASK.CPF_WITH_CNPJ
        : DOCUMENT_MASK.CNPJ;
    },
  },
};
</script>

<style scoped>
.inputData > input {
  width: 100%;
}

.selectStyle {
  font-size: 1rem !important;
}
</style>
